import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetIpInefficientUseRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IpAudit/IpInefficientUse`,
	params: { userId }
});
